<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("returnScan.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button :plain="true" size="mini" @click="backToRecord">{{ $t("returnScan.returnRecord") }}
          <i class="fa fa-list-ul"></i>
        </el-button>
        <el-button :plain="true" type="primary" size="mini" @click="confirmDialogVisible=true" :disabled="!hasScanned">{{ $t("returnScan.commitReturn") }}
          <i class="fa fa-hand-pointer-o"></i>
        </el-button>
        <el-button type="warning" :plain="true" size="mini" @click="resetScanInfo" :disabled="!hasScanned">{{ $t("reset") }}
          <i class="fa fa-eraser"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list">
      <div class="scan-input">
        <el-form class="search-form" status-icon>
          <el-form-item>
            <el-input ref="qrCodeInput" :autofocus="true" :placeholder="$t('returnScan.scanQrc1')" v-model="scanCode" @keydown.native.enter.prevent="commitQRCode" :disabled="loadingInput" :suffix-icon="loadingIcon">
              <span slot="prepend">
                {{$t('returnScan.qrcode')}}
              </span>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="scan-info">
        <div class="current-info">
          {{this.$t('returnScan.currentInfo',{count:this.scanEntries.length})}}
        </div>
        <el-table border stripe :data="scanEntries" size="mini" class="customer-table">
          <el-table-column align="center" :resizable="true" :label="this.$t('operation')" width="60">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteScanInfo(scope.row.Code)">{{$t('delete')}}</el-button>
            </template>
          </el-table-column>

          <el-table-column :key="col.prop" v-for="col in tableCols" align="center" :prop="col.prop" :resizable="true" :label="$t(col.label)" :show-overflow-tooltip="true" :width="col.width">
          </el-table-column>
        </el-table>
      </div>

      <!--confirm dialog-->
      <el-dialog class="tip-dialog" width="30%" :visible.sync="confirmDialogVisible" center>
        <div class="tip-info">
          <div class="title">
            <i class="el-icon-warning"></i>
            {{$t("tip")}}
          </div>
          <p class="msg">
            {{$t("returnScan.commitConfirmMsg")}}
          </p>
        </div>
        <el-input type="textarea" :rows="3" :placeholder="$t('returnScan.returnRemarkTip')" v-model="remark"></el-input>
        <div slot="footer" class="search-footer">
          <el-button @click="confirmDialogVisible = false" :plain="true" size="mini">{{$t('cancel')}}</el-button>
          <el-button type="primary" @click="commitReturn" :disabled="!hasScanned" :loading="processReturn" :plain="true" size="mini">{{$t('confirm')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import qrcodeService from "../../../services/qrcodeService";
import codeStatus from "../../../models/codeStatus";
import service from "./service";
export default {
  name: "ReturnScan",
  data() {
    return {
      scanEntries: [],
      loadingInput: false,
      confirmDialogVisible: false,
      processReturn: false,
      remark: "",
      scanCode: "",
      tableCols: [
        {
          prop: "Code",
          label: "returnScan.qrcode"
        },
        {
          prop: "BoxNumber",
          label: "returnScan.boxNumber"
        },
        {
          prop: "CustomerNumber",
          label: "returnScan.customerNum"
        },
        {
          prop: "CustomerName",
          label: "returnScan.customerName"
        },
        {
          prop: "OrderNumber",
          label: "returnScan.orderNum"
        },
        {
          prop: "EanCode",
          label: "returnScan.eanCode"
        },
        {
          prop: "ProductLongCode",
          label: "returnScan.pLongCode"
        },
        {
          prop: "ProductShortCode",
          label: "returnScan.pShortCode"
        },
        {
          prop: "DeliveryTime",
          label: "returnScan.deliveryTime"
        }
      ]
    };
  },
  methods: {
    commitQRCode() {
      let code = qrcodeService.getQRCode(this.scanCode);
      this.scanCode = code;
      if (!code) return;
      //是否已扫描
      if (this.scanEntries.some(e => e.Code === code)) {
        this.$alert(this.$t("returnScan.codeScanned"), "错误", {
          type: "error",
          callback: action => {
            this.scanCode = "";
          }
        });
        return;
      }

      this.loadingInput = true;
      this.$axios
        .get(`api/product/return/${code}`)
        .then(resp => {
          if (resp.data) {
            this.scanEntries.splice(0, 0, resp.data);
            service.write(this.scanEntries);
          }
          this.scanCode = "";
          this.loadingInput = false;
        })
        .catch(e => {
          var msg =
            (e.response && e.response.data) ||
            this.$t("returnScan.codeStatusError");
          this.$alert(msg, "错误", {
            type: "error",
            callback: action => {
              this.scanCode = "";
            }
          });
          this.loadingInput = false;
        });
    },
    commitReturn() {
      let params = {
        remark: this.remark,
        codes: this.scanEntries.map(e => e.Code)
      };
      this.processReturn = true;
      this.$axios
        .post(`api/product/return`, params)
        .then(resp => {
          this.clearInfo();
          this.$message({
            type: "success",
            message: this.$t("returnScan.returnSuccess")
          });
          this.confirmDialogVisible = false;
          this.processReturn = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: this.$t("operationFailure")
          });
          this.processReturn = false;
        });
    },
    initializeScanInfo() {
      let info = service.read();
      this.scanEntries = info;
    },
    backToRecord() {
      this.$router.push({ name: "ProductReturn" });
    },
    resetScanInfo() {
      this.$confirm(this.$t("returnScan.clearConfirm"), this.$t("tip"), {
        type: "warning"
      })
        .then(() => {
          this.clearInfo();
          this.$message({
            type: "success",
            message: this.$t("returnScan.clearSuccess")
          });
        })
        .catch(() => {});
    },
    clearInfo() {
      this.scanEntries = [];
      this.scanCode = "";
      service.clear();
    },
    deleteScanInfo(code) {
      this.$confirm(this.$t("returnScan.deleteConfirm"), this.$t("tip"), {
        type: "warning"
      })
        .then(() => {
          this.scanEntries = this.scanEntries.filter(e => e.Code !== code);
          service.write(this.scanEntries);
          this.$message({
            type: "success",
            message: this.$t("deleteSuccess")
          });
        })
        .catch(() => {});
    }
  },
  computed: {
    loadingIcon() {
      return this.loadingInput ? "el-icon-loading" : "";
    },
    hasScanned() {
      return this.scanEntries.length;
    }
  },
  created() {
    this.initializeScanInfo();
  },
  updated() {
    if (!this.confirmDialogVisible) this.$refs["qrCodeInput"].focus();
  }
};
</script>

<style lang="scss">
.current-info {
  padding-bottom: 10px;
  font-size: 17px;
}

.tip-info {
  text-align: center;
  .title {
    font-size: 20px;
    .el-icon-warning {
      color: #e6a23c;
      font-size: 25px;
    }
  }

  .msg {
    font-size: 15px;
  }
}

.tip-dialog {
  .el-dialog__body {
    padding-top: 5px;
    padding-bottom: 15px;
  }
}
</style>









// WEBPACK FOOTER //
// src/components/application/ProductReturn/ReturnScan.vue